import "UI/Widget/Forms/Control/Input";
NS("UI.Widget.Forms.Control");

UI.Widget.Forms.Control.TextArea = Class(UI.Widget.Forms.Control.Input, {
    createElement: function() {
    	if (this.$control.attr('linecount') == 1)
			this.$element = $("<input type='text'></input>");
    	else
        	this.$element = $("<textarea rows='"+(this.$control.attr('linecount')?this.$control.attr('linecount'):3)+"'></textarea>");
    }
});
